import "./hexapi.css";
import logoimg from '../../assets/logotrackhr.png'
import axios from 'axios';
import { StringFormatter } from './StringFormatter';
import { Aesdecryption, Aesencryption } from '../Aes/Aes';
import Swal from 'sweetalert2';
import { secureGet } from "../secureStorage";

const lowercaseKeyshashmap = (data) => {
  if (Array.isArray(data)) {
    return data.map(item => lowercaseKeyshashmap(item));
  } else if (typeof data === "object" && data !== null) {
    return Object.entries(data).reduce((acc, [key, value]) => {
      acc[key.toLowerCase()] = lowercaseKeyshashmap(value);
      return acc;
    }, {});
  } else {
    return data;
  }
};

let cachedApiPath = null;
let apiPromise = null;

const apicall = async () => {
  if (cachedApiPath) return cachedApiPath;

  if (!apiPromise) {
    apiPromise = axios.get("./Apiinfo.json").then(res => {
      cachedApiPath = res.data?.apipathurl;
      return cachedApiPath;
    });
  }

  return apiPromise;
};

// ── HMAC signature helpers ──────────────────────────────────────────────────

const CLIENT_SECRET = "j0ydceKjxqG55/DTxaSy4Z2PfGpbTj0sGg+ejXxrWk=";
const SIGN_PATH     = "2fDNi6gASbiszyo9.php";

/**
 * HMAC-SHA256 using the Web Crypto API.
 * Returns a lowercase hex string.
 */
const hmacSHA256 = async (secret, message) => {
  const enc     = new TextEncoder();
  const keyData = enc.encode(secret);
  const msgData = enc.encode(message);

  const cryptoKey = await crypto.subtle.importKey(
    "raw", keyData,
    { name: "HMAC", hash: "SHA-256" },
    false,
    ["sign"]
  );

  const sig    = await crypto.subtle.sign("HMAC", cryptoKey, msgData);
  const bytes  = new Uint8Array(sig);
  return Array.from(bytes).map(b => b.toString(16).padStart(2, "0")).join("");
};


/**
 * Build the two headers the PHP endpoint requires:
 *   x-timestamp  – current UTC time as "YYYY-MM-DD HH:MM:SS"
 *   x-signature  – HMAC-SHA256( METHOD + PATH + timestamp )
 *
 * Body hashing is omitted because POST field names are AES-encrypted,
 * making server-side reconstruction impossible. The payload is already
 * protected by AES-256, and replay attacks are blocked by the 60-second
 * timestamp window.
 */
const buildSignatureHeaders = async () => {
  const now       = new Date();
  const pad       = n => String(n).padStart(2, "0");
  const timestamp =
    `${now.getUTCFullYear()}-${pad(now.getUTCMonth() + 1)}-${pad(now.getUTCDate())} ` +
    `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}`;

  const canonical = `POST${SIGN_PATH}${timestamp}`;
  const signature = await hmacSHA256(CLIENT_SECRET, canonical);

  return { "x-timestamp": timestamp, "x-signature": signature };
};

// ───────────────────────────────────────────────────────────────────────────

const Hexapi = async(props, Retryfunction, value, report) => {
  const apipathurl = await apicall();

  if (!apipathurl) {
    console.error("API Path URL not found");
    return Promise.reject("API Path URL not found");
  }

  const userid = await secureGet("item");
  console.log(userid, "userid");

  return new Promise((resolve, reject) => {

    let url = `${apipathurl}2fDNi6gASbiszyo9.php`;

    const sendRequest = async () => {
      try {
        let fd = new FormData();
        let sqlquery = "";

        if (props.query && props.queryArr) {
          let formattedQueryString = StringFormatter(props.query, props.queryArr);
          sqlquery = formattedQueryString;
          console.log("Formatted Query:", formattedQueryString);
          fd.append(Aesencryption("Query"), Aesencryption(formattedQueryString.replaceAll('"', '$#12#$')));
        }

        if (props.file !== undefined) {
          fd.append(Aesencryption("file"), props.file);
        }

        if (props.usercode != undefined) {
          fd.append(Aesencryption('usercode'), Aesencryption(props.usercode));
        }

        if (props.orgdbname !== undefined && props.userid !== undefined && props.salaryid !== undefined) {
          fd.append(Aesencryption('OrgDbName'), Aesencryption(props.orgdbname));
          fd.append(Aesencryption('UserID'),    Aesencryption(props.userid));
          fd.append(Aesencryption('SalaryID'),  Aesencryption(String(props.salaryid)));
        }

        if (props.autologin != undefined) {
          fd.append(Aesencryption('autologin'), Aesencryption(props.autologin));
        }

        if (props.clientdetails != undefined) {
          fd.append(Aesencryption('clientdetails'), Aesencryption(props.clientdetails));
        }

        let encryptedDbname;
        if (props.dbname !== undefined) {
          console.log(props.dbname, "props.dbname");
          encryptedDbname = Aesencryption(props.dbname);
        } else {
          console.log(localStorage.getItem("orgdbname"), "props.dbname--------------");
          encryptedDbname = Aesencryption(localStorage.getItem("orgdbname"));
        }
        fd.append(Aesencryption('dbname'), encryptedDbname);

        // ── Build HMAC signature headers ──────────────────────────────────
        const signatureHeaders = await buildSignatureHeaders();
        // ─────────────────────────────────────────────────────────────────

        const resp = await axios({
          mode:    'cors',
          method:  "POST",
          headers: {
            "Content-Type": "multipart/form-data",
            ...signatureHeaders,
          },
          url:  url,
          data: fd,
        });
console.log(resp,"resp.data")
        let decrypted    = Aesdecryption(resp.data);
        // console.log(decrypted,"decrypted")
        let responseData = decrypted && JSON.parse(decrypted);
console.log(responseData,"responseData")
        const lowerCasedReports = lowercaseKeyshashmap(responseData);

        if (responseData?.sqlerrors) {
          const clientDetails = navigator.userAgent;
          await logError(responseData, sqlquery, clientDetails);
          if (value == 1) {
            showRetryDialog();
          } else {
            reject(new Error("SQL Error occurred"));
          }
        } else {
          Swal.close();
          if (report == 1) {
            resolve({
              lowerCasedReports:    lowerCasedReports,
              originalresponseData: responseData,
            });
          } else {
            resolve(lowerCasedReports);
          }
        }
      } catch (error) {
        console.error(`Axios error in query: ${props.query}`, error);
        if (value == 1) {
          showRetryDialog();
        }
        reject(error);
      }
    };

    const logError = async (errorData, sqlquery, clientDetails) => {
      let errorQuery = `[dbo].[Hex_Web_Proc_ErrorLog_Submit]
          @UserID='{0}',
          @ErrorCode='{1}',
          @ErrorMessage='{2}',
          @SqlState='{3}',
          @ClientDetails='{4}',
          @Query='{5}'`;

      let queryArr = [
        `${userid}`,
        `${errorData.sqlerrors.code[0]}`,
        `${errorData.sqlerrors.message[0]}`,
        `${errorData.sqlerrors.sqlstate[0]}`,
        `${clientDetails}`,
        `${sqlquery}`,
      ];

      let formattedQueryString = StringFormatter(errorQuery, queryArr);
      console.log(formattedQueryString, "formatted");

      let errorFormData = new FormData();
      errorFormData.append(Aesencryption("Query"), Aesencryption(formattedQueryString));

      let encryptedDbname;
      if (props.dbname !== undefined) {
        console.log(props.dbname, "props.dbname");
        encryptedDbname = Aesencryption(props.dbname);
      } else {
        console.log(localStorage.getItem("orgdbname"), "props.dbname--------------");
        encryptedDbname = Aesencryption(localStorage.getItem("orgdbname"));
      }
      errorFormData.append(Aesencryption('dbname'), encryptedDbname);

      // Sign the error-log request too
      const errSignatureHeaders = await buildSignatureHeaders();

      try {
        console.log(url, "url");
        const errorResponse = await axios.post(url, errorFormData, {
          mode:    "cors",
          headers: {
            "Content-Type": "multipart/form-data",
            ...errSignatureHeaders,
          },
        });

        let errorResp = JSON.parse(Aesdecryption(errorResponse.data));
        console.log("Error log response:", errorResp);
      } catch (error) {
        console.error("Error logging failed", error);
      }
    };

    const showRetryDialog = () => {
      Swal.fire({
        html: `
          <div style="color: #fff; font-size: 16px; padding:0px; display: flex; justify-content: start; align-items: center;">
            <img src="${logoimg}" alt="Error Image" style="width: 30px; height: 30px; margin-right: 20px;">
            An Error Occurred. Click
            <span id="retry-text" style="color: #29b6f6; cursor: pointer; font-weight: bold; margin: 0 4px;">
              Retry
            </span>
            to try again.
          </div>
        `,
        background:       "#121212",
        showCloseButton:  true,
        allowOutsideClick: false,
        showConfirmButton: false,
        position:         "bottom-left",
        didOpen: () => {
          const event = new CustomEvent("swalOpened", { detail: { message: "Swal is opened" } });
          window.dispatchEvent(event);
          document.getElementById("retry-text").addEventListener("click", retryRequest);
        },
        willClose: () => {
          const event = new CustomEvent("swalClosed", { detail: { message: "Swal is closed" } });
          window.dispatchEvent(event);
          reject(new Error("User closed the retry dialog"));
        },
        customClass: { popup: "my-custom-swal" },
      });
    };

    const retryRequest = async () => {
      try {
        Swal.fire({
          html: `
            <div style="margin-bottom: 2px;">
              <img src="${logoimg}" alt="Error Image" style="width: 28px; height: 28px; margin-right: 20px;">
              <span style="color: white; font-size:16px;">Retrying.....</span>
              <div style="width: 100%; height: 6px; overflow: hidden; margin-top:4px;">
                <div id="progress-bar" style="width: 0%; height: 100%; background: #29b6f6;"></div>
              </div>
            </div>
          `,
          allowOutsideClick:  false,
          showConfirmButton:  false,
          background:         "#121212",
          position:           "bottom-start",
          customClass:        { popup: "my-custom-swal2" },
          didOpen: () => {
            let progress    = 0;
            const progressBar = document.getElementById("progress-bar");
            const interval  = setInterval(() => {
              progress += 1;
              progressBar.style.width = `${progress}%`;
              if (progress >= 100) clearInterval(interval);
            }, 6);
          },
        });

        await new Promise(resolve => setTimeout(resolve, 700));
        Retryfunction();
        Swal.close();
      } catch (error) {
        console.error("Retry failed:", error);
        showRetryDialog();
      }
    };

    sendRequest();
  });
};

export default Hexapi;


// import "./hexapi.css";
// import logoimg from '../../assets/logotrackhr.png'
// import axios from 'axios';
// import { StringFormatter } from './StringFormatter';
// import { Aesdecryption, Aesencryption } from '../Aes/Aes';
// import Swal from 'sweetalert2';
// import { secureGet } from "../secureStorage";

// const lowercaseKeyshashmap = (data) => {
//   if (Array.isArray(data)) {
//     return data.map(item => lowercaseKeyshashmap(item));
//   } else if (typeof data === "object" && data !== null) {
//     return Object.entries(data).reduce((acc, [key, value]) => {
//       acc[key.toLowerCase()] = lowercaseKeyshashmap(value);
//       return acc;
//     }, {});
//   } else {
//     return data;
//   }
// };

// let cachedApiPath = null;
// let apiPromise = null;

// const apicall = async () => {
//   if (cachedApiPath) return cachedApiPath;

//   if (!apiPromise) {
//     apiPromise = axios.get("./Apiinfo.json").then(res => {
//       cachedApiPath = res.data?.apipathurl;
//       return cachedApiPath;
//     });
//   }

//   return apiPromise;
// };

// const Hexapi = async(props, Retryfunction, value,report) => {
    
//      const apipathurl = await apicall();  

//     if (!apipathurl) {
//         console.error("API Path URL not found");
//         return Promise.reject("API Path URL not found");
//     }
// const userid = await secureGet("item")

//     return new Promise((resolve, reject) => {
 
//         let url = `${apipathurl}fetchrsdatadbV5.php`;
//         const sendRequest = async () => {
//             try {
//                 let fd = new FormData();
//                 let sqlquery = "";

//                 if (props.query && props.queryArr) {
//                     console.log(props.query,"edfgcwsjkqjlk")
//                     let formattedQueryString = StringFormatter(props.query, props.queryArr);
//                                         sqlquery = formattedQueryString;
//                                         console.log("Formatted Query:", formattedQueryString);
//                                         fd.append(Aesencryption("Query"), Aesencryption(formattedQueryString.replaceAll('"', '$#12#$')));
//                 }
//  if (props.file !== undefined) {
          
//             fd.append(Aesencryption("file"),  props.file)
//         }
//                  if (props.usercode != undefined) {
//         fd.append(Aesencryption('usercode'), Aesencryption(props.usercode))
//     }
//       if (props.orgdbname !== undefined && props.userid !==undefined && props.salaryid !==undefined) {
//             fd.append(Aesencryption('OrgDbName'), Aesencryption(props.orgdbname));
//             fd.append(Aesencryption('UserID'), Aesencryption(props.userid));
//             fd.append(Aesencryption('SalaryID'), Aesencryption(String(props.salaryid)));
//         } 
//     if (props.autologin != undefined) {
//         fd.append(Aesencryption('autologin'), Aesencryption(props.autologin))
//     }

//     if (props.clientdetails != undefined) {
//         fd.append(Aesencryption('clientdetails'), Aesencryption(props.clientdetails))
//     }
//     if (props.dbname !== undefined) {
//        console.log(props.dbname,"props.dbname")
//         fd.append(Aesencryption('dbname'), Aesencryption(props.dbname))
//     }else{
//          console.log(localStorage.getItem("orgdbname"),"props.dbname--------------")
//         fd.append(Aesencryption('dbname'), Aesencryption(localStorage.getItem("orgdbname")))

//     }
 
//                 const resp = await axios({
//                                         mode: 'cors',
//                                         method: "POST",
//                                         headers: { "Content-Type": "multipart/form-data" },
//                                         url: url,
//                                         data: fd
//                                     })



// let decrypted = Aesdecryption(resp.data);
//                 let responseData = JSON.parse(decrypted);
// console.log(responseData,"responsedata")
// const lowerCasedReports = lowercaseKeyshashmap(responseData)

//                 if (responseData?.sqlerrors) {
//                     const clientDetails = navigator.userAgent;
//                     await logError(responseData, sqlquery,clientDetails);
//                     if (value == 1) {
//                         showRetryDialog();
//                     } else {
//                         reject(new Error("SQL Error occurred"));
//                     }
//                 } else {
//                     Swal.close();
//                     if(report == 1){
//                         resolve({
//                         lowerCasedReports:lowerCasedReports,
//                         originalresponseData:responseData
//                        });
//                     }else{
//                        resolve(lowerCasedReports);
//                     }

//                 }
//             } catch (error) {
//                   if (
//                     error?.code === "ERR_CANCELED" || 
//                     error?.message === "canceled" ||
//                     error?.name === "CanceledError" ||
//                     error?.name === "AbortError"
//                 ) {
//                     console.warn("Request cancelled due to tab switch, ignoring.");
//                     resolve({});
//                     return;
//                 }
//                 console.error(`Axios error in query: ${props.query}`, error);
//                 if(value == 1){
//                     showRetryDialog();
//                 }
//                 reject(error);
//             }
//         };

//         const logError = async (errorData, sqlquery, clientDetails) => {
//                         let errorQuery = `[dbo].[Hex_Web_Proc_ErrorLog_Submit]
//                             @UserID='{0}',
//                             @ErrorCode='{1}',
//                             @ErrorMessage='{2}',
//                             @SqlState='{3}',
//                             @ClientDetails='{4}',
//                             @Query='{5}'`;

//                         let queryArr = [
//                             `${userid}`,
//                             `${errorData.sqlerrors.code[0]}`,
//                             `${errorData.sqlerrors.message[0]}`,
//                             `${errorData.sqlerrors.sqlstate[0]}`,
//                             `${clientDetails}`,
//                             `${sqlquery}`
//                         ];

//                         let formattedQueryString = StringFormatter(errorQuery, queryArr);
                     
//                         let errorFormData = new FormData();
//                         errorFormData.append(Aesencryption("Query"), Aesencryption(formattedQueryString));
//   if (props.dbname !== undefined) {
    
//         errorFormData.append(Aesencryption('dbname'), Aesencryption(props.dbname))
//     }else{
        
//         errorFormData.append(Aesencryption('dbname'), Aesencryption(localStorage.getItem("orgdbname")))
//     }
//                         try {
                            
//                             const errorResponse = await axios.post(url, errorFormData, {
//                                 mode: "cors",
//                                 headers: { "Content-Type": "multipart/form-data" }
//                             });

//                             let errorResp = JSON.parse(Aesdecryption(errorResponse.data));
                    
//                         } catch (error) {
//                             console.error("Error logging failed", error);
//                         }
//                     };


//                     const showRetryDialog = () => {


//             Swal.fire({
//                 html: `
//                     <div style="color: #fff; font-size: 16px; padding:0px; display: flex; justify-content: start; align-items: center;">
//                         <img src="${logoimg}" alt="Error Image" style="width: 30px; height: 30px; margin-right: 20px;">
//                         An Error Occurred. Click
//                         <span id="retry-text" style="color: #29b6f6; cursor: pointer; font-weight: bold; margin: 0 4px;">
//                             Retry
//                         </span>
//                         to try again.
//                     </div>
//                 `,
//                 background: "#121212",
//                 showCloseButton: true,
//                 allowOutsideClick: false,
//                 showConfirmButton: false,
//                 position: "bottom-left",
//                 didOpen: () => {
//                     const event = new CustomEvent("swalOpened", { detail: { message: "Swal is opened" } });
//                     window.dispatchEvent(event);
//                     document.getElementById("retry-text").addEventListener("click", retryRequest);
//                 },
//                 willClose: () => {
//                     const event = new CustomEvent("swalClosed", { detail: { message: "Swal is closed" } });
//                     window.dispatchEvent(event);
//                     reject(new Error("User closed the retry dialog"));
//                 },
//                 customClass: {
//                     popup: "my-custom-swal"
//                 }
//             })
//         };

//         const retryRequest = async () => {
//              try {
//                     Swal.fire({
//                         html: `
//                             <div style="margin-bottom: 2px;">
//                                 <img src="${logoimg}" alt="Error Image" style="width: 28px; height: 28px; margin-right: 20px;">
//                                 <span style="color: white; font-size:16px;">Retrying.....</span>
//                                 <div style="width: 100%; height: 6px; overflow: hidden; margin-top:4px;">
//                                     <div id="progress-bar" style="width: 0%; height: 100%; background: #29b6f6;"></div>
//                                 </div>
//                             </div>
//                         `,
//                         allowOutsideClick: false,
//                         showConfirmButton: false,
//                         background: "#121212",
//                         position: "bottom-start",
//                         customClass: {
//                             popup: "my-custom-swal2"
//                         },
//                         didOpen: () => {
//                             let progress = 0;
//                             const progressBar = document.getElementById("progress-bar");
//                             const interval = setInterval(() => {
//                                 progress += 1;
//                                 progressBar.style.width = `${progress}%`;
//                                 if (progress >= 100) {
//                                     clearInterval(interval);
//                                 }
//                             }, 6);
//                         }
//                     });

//                     await new Promise(resolve => setTimeout(resolve, 700));
//                     Retryfunction();
//                     Swal.close();
//                 } catch (error) {
//                     console.error("Retry failed:", error);
//                     showRetryDialog();
//                 }
//             }

//         sendRequest();
//     });
// };

// export default Hexapi;